import BaseService from "./base.service";

export default class NewsService extends BaseService {

    constructor(ctx) {
        super(ctx)
    }

    getNewsCategoryList = (query) => {
        return this.get('/news/news-category-list', query);
    }

    getNewsByCategory = (query) => {
        return this.get('/news/news-by-category', query)
    }

    getTopNewsByCategoryId = (query) => {
        return this.get('/news/top-news-by-category', query)
    }

    getNewsList = (query) => {
        return this.get('/news', query);
    }

    getNewsById = (news_id, query) => {
        return this.get(`/news/${news_id}`, query)
    }

    getNewsCategory = (query) => {
        return this.get('/news/category', query)
    }

    getServicePackageList = (query) => {
        return this.get('/news/service-package', query);
    }

}
